module.exports = __webpack_public_path__ + "static/media/decor-problem1.de62f11d.png";